import _ from "underscore"
import TemplateView from "../TemplateView"
import LoadingControlMixin from "../controls/LoadingControlMixin"
import {fixIScrollInnerWheelEvent, handleEscape} from "../atBrowserUtils"
import {trim} from "../atUtils"

const MAX_LENGTH_LIMIT = 50000

export default class ResizableInput extends TemplateView {
    constructor({
        showCounter = true,
        heightLimit = 200,
        minHeight = 64,
        maxLength = 2000,
        allowInputOverMaxLength = false,
        additionalClass = '',
        onKeyDown = () => {},
        onFocus = () => {},
        onBlur = () => {},
        onChange = () => {},
        onResize = () => {},
    } = {}) {
        super()

        this.params = {
            additionalClass,
            onKeyDown,
            onFocus,
            onBlur,
            showCounter,
            heightLimit,
            minHeight,
            maxLength,
            allowInputOverMaxLength,
            onChange,
            onResize,
        }

        this.state = {
            editing: false,
            editable: true,
            text: '',
            placeholder: '',
        }

        this.onStatePropertyChanged('text', () => this._handleTextChanged())
        this.onStatePropertyChanged('placeholder', () => this.$input.attr('placeholder', this.state.placeholder).placeholder())

        this.onStatePropertyChanged('editable', editable => {
            this.$el.toggleClass('editable', editable)
            this.$input.attr('disabled', !editable)
        })
    }

    templateHtml() {
        return "<div class='components_resizableInput <%=additionalClass%>'>" +
               "  <div class='inputContainer'><textarea class='textarea' maxlength='<%=maxLength%>'/></div>" +
               "  <div class='characterCounter'></div>" +
               "</div>";
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            maxLength: this.params.allowInputOverMaxLength ? MAX_LENGTH_LIMIT : this.params.maxLength
        }
    }

    afterRender() {
        this.$input = this.find('.textarea');
        this.textarea = this.find('textarea')[0];
        this.$inputContainer = this.find('.inputContainer');
        this.$counter = this.find('.characterCounter');

        this.$input.blur(() => this._onBlur());
        this.$inputContainer.click(() => this._onFocus());
        fixIScrollInnerWheelEvent(this.$input);

        this.$input.keyup(() => {
            this.updateResize();
            this.counterUpdate();
        });

        this.$input.keydown((e) => {
            this.params.onKeyDown(e);
            handleEscape(() => {
                e.stopPropagation();
                this.$input.blur();
            }, e);
        });

        this.$input.on('input', this._handleOnInputChange)

        this.$counter.hide();
    }

    /* ugly hack for resizing textarea
    *  additional line height needs for hiding scroll while textarea is resizing
    * */
    updateResize() {
        const lineHeight = 22;
        const additionalHeight = this.state.editing ? lineHeight : 0
        // refresh scroll
        const prevHeight = this.getEl().height()

        this.textarea.style.height = "0px";
        this.textarea.style.height = Math.max(this.params.minHeight, Math.min(this.textarea.scrollHeight + additionalHeight, this.params.heightLimit)) + "px";

        if (prevHeight !== this.getEl().height()) {
            this.params.onResize()
        }
    }

    getText() {
        return this.$input.pVal();
    }

    counterUpdate() {
        if (this.params.showCounter) {
            var characterCount = trim(this.$input.pVal()).length;
            var counterText = characterCount + "/" + this.params.maxLength;
            this.$counter.text(counterText);

            if (characterCount <= this.params.maxLength)
                this.clearError();
            else
                this.setError();
        }
    }

    setError() {
        this.$el.addClass("invalid");
        this.invalid = true;
    }

    clearError() {
        this.$el.removeClass("invalid");
        this.invalid = false;
    }

    focus() {
        this.$input.focus()
        this.updateResize()
        this._onFocus()
    }

    _onFocus() {
        this.updateResize()
        this.setStateInternal({editing: true})
        if (!this.state.editable)
            return;

        if (this.params.showCounter)
            this.$counter.show();

        this.params.onFocus()
    }

    _onBlur() {
        this.setStateInternal({editing: false})
        var newText = trim(this.$input.pVal());
        if (newText !== this.state.text && !this.invalid) {
            this.trigger('change', newText);
            // this.params.onChange(newText);  - uncomment after refactoring
        }

        if (!this.invalid) {
            this.$counter.hide();
        }
        this.params.onBlur(newText);
    }

    _handleOnInputChange = (e) => {
        const text = e.target.value.trim()
        this.params.onChange(text)
    }

    _handleTextChanged() {
        this.$input.pVal(this.state.text);
        this.updateResize();
        this.counterUpdate();
    }
}

_.extend(ResizableInput.prototype, LoadingControlMixin);


// WEBPACK FOOTER //
// ./web/js/panels/ResizableInput.js